import { render, staticRenderFns } from "./passengerFlow.vue?vue&type=template&id=19f8995d&scoped=true&"
import script from "./passengerFlow.vue?vue&type=script&lang=js&"
export * from "./passengerFlow.vue?vue&type=script&lang=js&"
import style0 from "./passengerFlow.vue?vue&type=style&index=0&id=19f8995d&lang=less&scoped=true&"
import style1 from "./passengerFlow.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8995d",
  null
  
)

export default component.exports